import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

const ContactHero = () => {
   return (
      <section className="contact-hero p-relative fix">
         <div className="tw-container tw-mx-auto tw-text-center">
            <span className="contact-hero__badge">Contact Us</span>
            <h1 className="contact-hero__heading">Let's <span className="contact-hero__accent">Connect</span></h1>
            <p className="contact-hero__subtitle">We look forward to hearing about your project.</p>

            <div className="contact-hero__info">
               <div className="contact-hero__info-item">
                  <span className="contact-hero__info-icon"><MapPin size={18} /></span>
                  <span>Hyderabad, Telangana</span>
               </div>
               <div className="contact-hero__info-item">
                  <span className="contact-hero__info-icon"><Phone size={18} /></span>
                  <a href="tel:+919030350309">+91-90303 50309</a>
               </div>
               <div className="contact-hero__info-item">
                  <span className="contact-hero__info-icon"><Mail size={18} /></span>
                  <a href="mailto:info@harsofts.com">info@harsofts.com</a>
               </div>
            </div>
         </div>
      </section>
   );
};

export default ContactHero;
